import { render, staticRenderFns } from "./reportcomponents.vue?vue&type=template&id=0b2ad6e0&scoped=true"
import script from "./reportcomponents.vue?vue&type=script&lang=js"
export * from "./reportcomponents.vue?vue&type=script&lang=js"
import style0 from "./reportcomponents.vue?vue&type=style&index=0&id=0b2ad6e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2ad6e0",
  null
  
)

export default component.exports